export default __webpack_public_path__ + "static/media/brand-logo-cny.d520afa5.png";